import * as React from 'react';

import { addAdFoxBanner } from '../';
import { IOffer } from '../../../../offer/types';
import { IMakeRequest } from '../../../../utils/request';

const style = require('./index.css');

export interface ISeoTopBannersProps {
  baseUrl: string;
  offers: IOffer[];
  isAgent: boolean;
  makeRequest: IMakeRequest;
  shouldSendAdsEvent?: boolean;
}

export class SeoTopBanners extends React.Component<ISeoTopBannersProps> {
  public render() {
    const banners = [];

    banners.push(this.getBanner(1), this.getBanner(2), this.getBanner(3));

    return <div className={style['container']}>{banners}</div>;
  }

  private getBanner = (id: number) => {
    return addAdFoxBanner({
      type: 'tgb_in_seo',
      key: `tgb_in_seo-${id}`,
      makeRequest: this.props.makeRequest,
      offer: this.props.offers[0],
      isAgent: this.props.isAgent,
      isNew: true,
      shouldSendAdsEvent: this.props.shouldSendAdsEvent,
    });
  };
}
